<template>
  <div class="md-layout">
    <md-dialog :md-active.sync="dialogVisible" id="outcome-dialog">
      <md-dialog-title>Enquiry Outcome</md-dialog-title>
      <md-dialog-content>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(createOutcome)">
            <div class="md-layout">
              <div class="md-layout-item md-size-40">
                <h6>Status</h6>
                <md-radio v-model="outcome.status" value="positive"
                  >Success</md-radio
                >
                <md-radio v-model="outcome.status" value="deferred"
                  >Deferred</md-radio
                >
                <md-radio v-model="outcome.status" value="negative"
                  >Failed</md-radio
                >

                <div class="deferred" v-if="followUpAvailable">
                  <h6>Follow-up Date</h6>
                  <date-picker
                    prefix-class="xmx"
                    v-model="outcome.follow_up"
                    valueType="format"
                    type="date"
                    placeholder="Select Follow-up Date"
                  ></date-picker>
                </div>
              </div>
              <div class="md-layout-item md-size-60">
                <h6>Content</h6>
                <text-editor v-model="outcome.content" />
              </div>
            </div>
            <md-dialog-actions>
              <md-button class="md-primary md-dense" @click="cancel"
                >Cancel</md-button
              >
              <md-button type="submit" class="md-primary md-dense"
                >Done</md-button
              >
            </md-dialog-actions>
          </form>
        </ValidationObserver>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
import enquiryApi from "@/services/api/enquiry";
import _filter from "lodash/filter";

export default {
  name: "EnquiryOutcomeDialog",

  props: ["enquiry", "showDialog"],

  data() {
    return {
      outcome: {
        content: "",
        status: "positive",
        follow_up: null
      }
    };
  },

  computed: {
    dialogVisible: function() {
      return this.showDialog;
    },
    followUpAvailable: function() {
      return this.outcome.status == "deferred";
    }
  },

  components: {},

  methods: {
    createOutcome() {
      let args = {
        enquiry: this.enquiry,
        outcome: this.outcome
      };

      enquiryApi.createOutcome(args).then(response => {
        this.$notify({
          timeout: 2500,
          message: "Enquiry Outcome Updated",
          icon: "thumb_up",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success"
        });

        this.$emit("update", {});
      });
    },

    cancel() {
      this.$emit("cancel");
    }
  },

  watch: {},

  mounted() {}
};
</script>
<style lang="scss" scoped>
.md-radio {
  margin: 5px 15px 5px 0;
  display: flex;
}

.xmx-datepicker {
  width: 100%;
  padding-bottom: 12px;
}

#outcome-dialog {
  &::v-deep {
    .md-dialog-container {
      width: 768px;
    }

    .ProseMirror {
      min-height: 200px;
      margin-bottom: 1rem;
    }
  }
}
</style>
